const SystemTableTestIdsScope = {
  SYSTEM_TABLE: 'system-table',
};

export const SystemTableTestIds = {
  // TableTabToolbar
  TAB_TOOLBAR: `${SystemTableTestIdsScope.SYSTEM_TABLE}.tab-toolbar`,
  TOOLBAR_TABS: `${SystemTableTestIdsScope.SYSTEM_TABLE}.toolbar-tabs`,

  // TableToolbar
  TOOLBAR: `${SystemTableTestIdsScope.SYSTEM_TABLE}.toolbar`,
  TOOLBAR_ADD_BUTTON: `${SystemTableTestIdsScope.SYSTEM_TABLE}.toolbar-add-button`,
  TOOLBAR_PRIMARY_TOOL_BUTTONS: `${SystemTableTestIdsScope.SYSTEM_TABLE}.toolbar-primary-tool-buttons`,
  TOOLBAR_TITLE_LABEL: `${SystemTableTestIdsScope.SYSTEM_TABLE}.toolbar-title-label`,
  TOOL_BUTTONS: `${SystemTableTestIdsScope.SYSTEM_TABLE}.tool-buttons`,

  // TableWrapper
  CONTENT_CONTAINER: `${SystemTableTestIdsScope.SYSTEM_TABLE}.content-container`,
};
